export * from './breakpoints';

export const DEFAULT_PAGE_SIZE = 10;

export const DEBOUNCE_VALUE = 300;
